import React from 'react';
import { POST } from 'api/api';
import { LAZADA_BONUS_DEEPLINK } from './affiliateConfig';
import 'css/affiliate.css';

export default function AffiliateCta({
  variant = 'strip',
  message,
  ctaId = LAZADA_BONUS_DEEPLINK.id,
  ctaUrl = LAZADA_BONUS_DEEPLINK.url,
  ctaLabel = LAZADA_BONUS_DEEPLINK.label,
}) {
  const handleClick = async () => {
    try {
      await POST('/lotto/action', {
        ctaType: ctaId,
        ctaDetail: `affiliate_cta_${variant}`,
      });
    } catch (error) {
      console.error('/lotto/action --> error: ', error);
    }
  };

  if (variant === 'pill') {
    return (
      <a
        href={ctaUrl}
        className="affiliate-pill"
        target="_blank"
        rel="sponsored noopener noreferrer"
        onClick={handleClick}
        aria-label={`${ctaLabel} — โฆษณา`}
      >
        <span className="affiliate-pill__icon" aria-hidden="true">🛒</span>
        {ctaLabel}
        <span className="affiliate-disclosure">โฆษณา</span>
      </a>
    );
  }

  return (
    <aside className={`affiliate-strip affiliate-strip--${variant}`} aria-label="ข้อเสนอจากพาร์ทเนอร์">
      <p className="affiliate-strip__message">{message}</p>
      <a
        href={ctaUrl}
        className="affiliate-strip__btn"
        target="_blank"
        rel="sponsored noopener noreferrer"
        onClick={handleClick}
      >
        {ctaLabel}
      </a>
      <span className="affiliate-disclosure">โฆษณา · {LAZADA_BONUS_DEEPLINK.sponsor}</span>
    </aside>
  );
}
